import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/services/advisory')({
  head: () => ({
    ...buildSeoHead({ path: '/services/advisory', ...ROUTE_META['/services/advisory'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Advisory', path: '/services/advisory' }])),
      jsonLdScript(buildWebPageSchema({ path: '/services/advisory', ...ROUTE_META['/services/advisory'] })),
    ],
  }),
});
